// extracted by mini-css-extract-plugin
export default {"submitButton":"index_submitButton__6o7to"};